import { render, staticRenderFns } from "./Participaciones.vue?vue&type=template&id=5780b81c&scoped=true&"
import script from "./Participaciones.vue?vue&type=script&lang=js&"
export * from "./Participaciones.vue?vue&type=script&lang=js&"
import style0 from "./Participaciones.vue?vue&type=style&index=0&id=5780b81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780b81c",
  null
  
)

export default component.exports